export const RouteUrls = {
	PAGE_NOT_FOUND: '/PageNotFound',
	FORBIDDEN: '/Forbidden',
	HOME: '/',
	HOME_APP: '/application/:applicationId',
	AUTHORIZE: '/authorize',
	ACTIVATE: '/activator/:applicationId',
	ACTIVATE_CLIENT: '/activate/clients/:applicationId',
	ACTIVATE_CONFIRM: '/activate/confirm/:applicationId',
	MARKETPLACE: 'https://marketplace.paycor.com',
	CLIENTACTIVATION: '/clientactivation',
	CLIENTREDIRECT: '/clientredirect',
	ACTIVATE_USERS: '/activate/users/:applicationId'
};
